export default __webpack_public_path__ + "static/media/calllightning.0eb3909e.png";